import React, { useEffect } from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react';
import { Form, Input } from 'antd'
import { ControlElement, ControlProps as JSFControlProps } from '@jsonforms/core';
import type { Rule } from "antd/es/form"
import { AppControlUISchema } from '../form-types';
import WithLabel from '../../ui/WithLabel/WithLabel';
import { FormIcon } from '../icon';
import { useFormValue } from '../hooks/useFormValue';

type ControlProps = Omit<JSFControlProps, "uischema"> & {
  data: string
  handleChange(path: string, value: string): void
  path: string
  uischema: AppControlUISchema<unknown> | ControlElement
}

const NumberControl: React.FC<ControlProps> = ({
  label,
  data,
  path,
  enabled,
  required,
  schema,
  uischema,
  handleChange,
}) => {
  const { default: defaultValue } = schema ?? {};
  const { columns = 1, placeholder, icon, extraRules } = uischema.options ?? {};

  const rules: Rule[] = [
    ...(required  ? [{ required: true, message: `${label} is required` }] : []),
    // ...(minLength ? [{ min: minLength, message: `${label} must be at least ${minLength} characters` }] : []),
    // ...(maxLength ? [{ max: maxLength, message: `${label} must be at most ${maxLength} characters` }] : []),
    ...(extraRules ?? [])
  ];

  const initialData = useFormValue({
    path,
    value: data,
    initialValue: data || defaultValue || null,
    handleChange
  })

  return (
    <Form.Item
      rules={rules}
      initialValue={initialData}
      name={path}
      validateTrigger='onSubmit'
      validateFirst
      style={{
        gridColumn: `span ${columns}`,
      }}
      getValueFromEvent={(e) => {
        const raw = e?.target?.value;
        const value = raw === '' ? null : Number(raw);
        handleChange(path, value);
        return value;
      }}
    >
      <WithLabel
        icon={<FormIcon name={icon} size={18} />}
        label={label}
        required={required}
      >
        <Input
          value={data ?? ''}
          aria-label={label || schema.description}
          disabled={!enabled}
          autoComplete="off"
          type='number'
          placeholder={placeholder}
        />

      </WithLabel>
    </Form.Item>
  )
};

export default withJsonFormsControlProps(NumberControl as any);
